export default __webpack_public_path__ + "static/yuffie-469717be18887513da2db24078d0d16d.png";